import { useEffect } from "react";
import { ExpansionPanel, ExpansionPanelContent } from "@progress/kendo-react-layout";
import { Reveal } from "@progress/kendo-react-animation"

interface WistiaPlayerProps {
    videoId: string,
    title: string,
    children?: React.ReactNode
}

interface ExpansionPanelWistiaPlayerProps extends WistiaPlayerProps {
    expanded: string,
    onAction: Function,
}

export const ExpansionPanelWistiaPlayer = (props: ExpansionPanelWistiaPlayerProps) => {
    return <ExpansionPanel
        title={'Video: ' + props.title}
        expanded={props.expanded === props.videoId}
        tabIndex={0}
        key={props.videoId}
        onAction={props.onAction(props.videoId)}>
        <Reveal>
            {props.expanded === props.videoId && (
                <ExpansionPanelContent>
                    <WistiaPlayer {...props}/>
                </ExpansionPanelContent>
            )}
        </Reveal>
    </ExpansionPanel>
}

export const WistiaPlayer = (props: WistiaPlayerProps) => {
    const elementId = 'wistia_embed_' + props.videoId;

    useEffect(() => {
        const wistiaVideoScript = document.createElement("script");
        wistiaVideoScript.src = 'https://fast.wistia.com/embed/medias/' + props.videoId + '.jsonp';
        wistiaVideoScript.async = true;

        const wistiaAssetScript = document.createElement("script");
        wistiaAssetScript.src = 'https://fast.wistia.com/assets/external/E-v1.js';
        wistiaAssetScript.async = true;

        const wistiaDiv = document.createElement("div");
        wistiaDiv.innerHTML = '<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;">' +
            '<div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;">' +
            '<div class="wistia_embed wistia_async_' + props.videoId + ' seo=false videoFoam=true" style="height:100%;position:relative;width:100%">' +
            '<div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;">' +
            '<img src="https://fast.wistia.com/embed/medias/' + props.videoId + '/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true" onload="this.parentNode.style.opacity=1;" />' +
            '</div></div></div></div>';

        const container = document.getElementById(elementId);
        container?.appendChild(wistiaVideoScript);
        container?.appendChild(wistiaAssetScript);
        container?.appendChild(wistiaDiv);


        return () => {
            if (container) {
                container.innerHTML = "";
            }
        }

    }, []);

    return <span style={{padding: '7px'}}>
        <h3>{props.title}</h3>
        <div style={{ width: '500px', padding: '4px' }} id={elementId}></div>
    </span>;
}